import http from "../http";
import ApiConstants from '../constants/ApiConstants';

class PaymentLogService {
    static getPaymentLogs(params) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.GET_PAYMENT_LOGS}`;
        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching payment logs: ', error);
                return Promise.reject(error);
            }
        );
    }
}

export default PaymentLogService;